import React, { useState, useEffect } from 'react';
import './App.css';
import PasswordScreen from './components/PasswordScreen';
import SetupScreen from './components/SetupScreen';
import TimerScreen from './components/TimerScreen';
import CompletionScreen from './components/CompletionScreen';

const CORRECT_PASSWORD = 'Ar12345#';

function App() {
  const [screen, setScreen] = useState('password');
  const [timerConfig, setTimerConfig] = useState({
    totalSeconds: 300,
    video: '',
    audios: []
  });

  // Check session auth on mount
  useEffect(() => {
    const isAuthenticated = sessionStorage.getItem('albertoTimerAuth') === 'true';
    if (isAuthenticated) {
      setScreen('setup');
    }
  }, []);

  const handlePasswordSubmit = (password) => {
    if (password === CORRECT_PASSWORD) {
      sessionStorage.setItem('albertoTimerAuth', 'true');
      setScreen('setup');
      return true;
    }
    return false;
  };

  const handleStartTimer = (config) => {
    setTimerConfig(config);
    setScreen('timer');
  };

  const handleTimerComplete = () => {
    setScreen('completion');
  };

  const handleNewTimer = () => {
    setScreen('setup');
  };

  const handleLock = () => {
    sessionStorage.removeItem('albertoTimerAuth');
    setScreen('password');
  };

  return (
    <div className="app" data-testid="app-root">
      {screen === 'password' && (
        <PasswordScreen onSubmit={handlePasswordSubmit} />
      )}
      {screen === 'setup' && (
        <SetupScreen onStart={handleStartTimer} onLock={handleLock} />
      )}
      {screen === 'timer' && (
        <TimerScreen
          totalSeconds={timerConfig.totalSeconds}
          video={timerConfig.video}
          audios={timerConfig.audios}
          onComplete={handleTimerComplete}
        />
      )}
      {screen === 'completion' && (
        <CompletionScreen onNewTimer={handleNewTimer} onLock={handleLock} />
      )}
    </div>
  );
}

export default App;